import React from 'react';
import styled from 'styled-components';
import SettingsForm from '../components/Settings/SettingsForm';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${props => props.theme.background};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.padding};
  flex-shrink: 0;
  background: ${props => props.theme.backgroundSecondary};
  border-bottom: 1px solid ${props => props.theme.border};
`;

const Title = styled.h2`
  color: ${props => props.theme.text};
  margin: 0;
  font-weight: 600;
  font-size: ${props => props.compact ? '1rem' : '1.5rem'};
`;

const Content = styled.div`
  flex: 1;
  overflow: auto;
  padding: ${props => props.padding};
`;

const Settings = () => {
  const { user } = useAuth();
  const { settings } = useData();
  
  const isPremium = (user?.subscription && user?.subscription !== 'free') || (user?.aiTier && user?.aiTier !== 'free');
  const isCompact = isPremium && settings?.display?.compactMode;
  const padding = isCompact ? '0.125rem' : '0.75rem';

  return (
    <Container>
      <Header padding={padding}>
        <Title compact={isCompact}>Settings</Title>
      </Header>
      <Content padding={padding}>
        <SettingsForm />
      </Content>
    </Container>
  );
};

export default Settings;